// routes
import { routes } from "../../../../features/routes/route.tsx";
// axios
import axios from "axios";
// @ts-ignore
import Cookies from "js-cookie";
// option
import AdminOptionSet from "../../../../config/adminOption.tsx";

export const ShowAgent = async (agentId) => {
    let token = Cookies.get('admin_token');
    const { AdminOption } = AdminOptionSet(token)
    const { data: response } = await axios.get(`${routes.api[0].address}/admin/agents/${agentId?.queryKey[1]}`, AdminOption);
    return response.data;
}